// import React from "react";
// import WordCloud from "react-d3-cloud";
// import { scaleOrdinal } from "d3-scale";
// import { schemePaired } from "d3-scale-chromatic";
// import ReactWordcloud from "react-wordcloud";



// interface RawWord {
//   text: string;
//   VALUE: number | undefined;
// }

// interface NormalizedWord {
//   text: string;
//   value: number;
// }

// interface Props {
//   words: RawWord[];
//   componentName: string;
//   youtube?: string
// }

// const WordCloudComponent: React.FC<Props> = ({ words, componentName, youtube }) => {
//   // Normalize and filter out invalid entries
//   const normalizedWords: NormalizedWord[] = words
//     .filter((w) => typeof w.VALUE === "number")
//     .map((w) => ({
//       text: w.text,
//       value: w.VALUE as number,
//     }));

//   const values = normalizedWords.map((w) => w.value);
//   const minValue = Math.min(...values);
//   const maxValue = Math.max(...values);

//   const fontSizeScale =
//     minValue === maxValue
//       ? () => 30 // fallback if all values are equal
//       : (value: number) =>
//         ((value - minValue) / (maxValue - minValue)) ** 1.5 * 60 + 20; // 20–60 range

//   const customColors = ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C", "#FF9F1C"];
// const colorScale = scaleOrdinal(customColors);
// function getFontSizes(): [number, number] {
//   const min = 20;
//   const max = 60;
//   return [min, max];
// }

// const fontSizes = getFontSizes(); 
// const options = {
//   colors: ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C", "#FF9F1C"],
//   enableTooltip: false,
//   deterministic: true,
//   fontFamily: "Helvetica",
//   fontSizes: fontSizes, // Reduce max font size
//   fontStyle: "normal",
//   fontWeight: "bolder",
//   padding: 0, // Reduce or remove padding
//   rotations: 1, // More attempts = more layout flexibility
//   rotationAngles: [0, 45], // Narrower angle range
//   scale: "sqrt",
//   spiral: "archimedean",
//   transitionDuration: 500,
// };
// console.log('Normalized Words:', normalizedWords);
//   return (
//     <div className={`sec-word-cloud ${youtube === 'true' ? 'yt-wordcloud' : ""}`}>
//       <section className="brand-insight-highchart">
//         {!(youtube === 'true') &&
//           <div className="brand-insight-highchart-top">
//             <strong className="brand-insight-highchart-title d-flex flex-column">
//               {componentName}
//             </strong>
//           </div>
//         }

//         <div className="brand-insight-highchart-data">
//           <ReactWordcloud
//             words={normalizedWords}
//             options={{
//               colors: ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C", "#FF9F1C"],
//               enableTooltip: false,
//               deterministic: true,
//               fontFamily: "Helvetica",
//               fontSizes: [16, 20], 
//               fontStyle: "normal",
//               fontWeight: "bolder",
//               padding: 0, 
//               rotations: 2, 
//               rotationAngles: [0, 45],
//               scale: "sqrt",
//               spiral: "archimedean",
//               transitionDuration: 0,
//             }}
//             size={[420, 250]}
//           />
//         </div>
//       </section>
//     </div>
//   );
// };

// export default WordCloudComponent;

import React, { useRef, useState, useEffect, useMemo } from "react";
import ReactWordcloud from "react-wordcloud";

interface RawWord {
  text: string;
  VALUE: number | undefined;
}

interface NormalizedWord {
  text: string;
  value: number;
}

interface Props {
  words: RawWord[];
  componentName: string;
  youtube?: string;
}

const WordCloudComponent: React.FC<Props> = ({ words, componentName, youtube }) => {
  // Normalize and filter valid words
  const normalizedWords = useMemo(
    () =>
      words
        .filter((w) => typeof w.VALUE === "number")
        .map((w) => ({
          text: w.text,
          value: w.VALUE as number,
        })),
    [words]
  );

  // Track container size for responsive layout
  const containerRef = useRef<HTMLDivElement>(null);
  const [size, setSize] = useState<[number, number]>([300, 100]);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        setSize([width, height]);
      }
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`sec-word-cloud ${youtube === "true" ? "yt-wordcloud" : ""}`}>
      <section className="brand-insight-highchart">
        {youtube !== "true" && (
          <div className="brand-insight-highchart-top">
            <strong className="brand-insight-highchart-title d-flex flex-column">
              {componentName}
            </strong>
          </div>
        )}

        <div
          className="brand-insight-highchart-data"
          ref={containerRef}
          style={{
            width: "100%",
            height: "335px", // Adjust for taller or shorter word clouds
            overflow: "hidden", // Ensures words don't escape container
          }}
        >
          <ReactWordcloud
            words={normalizedWords}
            size={size}
            options={{
              colors: ["#FF6B6B", "#4ECDC4", "#FFD93D", "#1A535C", "#FF9F1C"],
              enableTooltip: false,
              deterministic: true,
              fontFamily: "Helvetica",
              fontSizes: [20, 50],
              fontStyle: "normal",
              fontWeight: "bolder",
              padding: 0,
              rotations: 2,
              rotationAngles: [0, 30],
              scale: "sqrt",
              spiral: "archimedean",
              transitionDuration: 0,
            }}
          />
        </div>
      </section>
    </div>
  );
};

export default WordCloudComponent;

